module.exports = __webpack_public_path__ + "static/media/title_logo.b08a35b0.png";